import { combineReducers } from 'redux';

import locations from './locationsReducer';
import partners from './partnersReducer';

const rootReducer = combineReducers({
  locations,
  partners
})

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js